<app-header />

<ion-content>
  <div class="alfred-client-container">
    <ion-card>
      <ion-card-content>
        <lib-alfred-client
          [showCloseBtn]="false"
          [sessionId]="(directLinkSessionId$ | async) || undefined"
          (finished)="navigateToHome()"
          (onCancelClick)="navigateToHome()"
        />
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
